import apiService from "./apiService";
import { IPromocodeDTO } from "./profile";

export const getAll = (): Promise<IPromocodeDTO[]> => {
  return apiService.get("/customer_api/v2/promocodes/");
};
